import { FormProvider, SubmitErrorHandler, SubmitHandler, useForm } from 'react-hook-form'
import { ButtonComponent } from '@syncfusion/ej2-react-buttons'
import { useEffect, useRef, useState } from 'react'
import { hideSpinner, showSpinner } from '@syncfusion/ej2-react-popups'
import styles from '../../styles/components/profile.module.scss'
import '../../styles/general/forms.scss'
import { useAppDispatch, useAppSelector } from '../../hooks/reduxHooks.tsx'
import { appRoles, protectedResources } from '../../global/config.tsx'
import { useOidcAccessToken, useOidcUser } from '@axa-fr/react-oidc'

import { fetchDataFromApi } from '../../services/fetchDataFromApi.tsx'
import { OidcUserExtendedInfo } from '../../types/OidcUserExtendedInfo.tsx'

import { ToastComponent } from '@syncfusion/ej2-react-notifications'

import { CommunicationData } from './components/CommunicationData.tsx'
import { GeneralData } from './components/GeneralData.tsx'
import { AddressData } from './components/AddressData.tsx'
import { BankData } from './components/BankData.tsx'
import { WebData } from './components/WebData.tsx'
import { QualificationsData } from './components/QualificationsData.tsx'
import { addRegistrationToList } from '../../redux/registerSlice.tsx'

import { MenuHeaderBar } from '../../components/global/MenuHeaderBar.tsx'
import { NwLecturerApplicationDto } from '../../types/NwLecturerApplicationDto.tsx'

import { DocumentsData } from './components/DocumentsData.tsx'
import RegistrationStatusMsg from './components/RegistrationStatusMsg.tsx'
import useToast from '../../components/global/NotificationToast.tsx'

import { VersionSelectDd } from './components/VersionSelectDd.tsx'
import SemiAddressAssignment from './components/SemiAddressAssignment.tsx'
import { useNavigate } from 'react-router-dom'
import TopicSelection from './components/TopicSelection.tsx'

import useFetchProfileData from '../../hooks/useFetchProfileData.tsx'
import useUserRoles from '../../hooks/useUserRoles.tsx'

const Profile = () => {
  const selectedRegIdxFromDd = useAppSelector((state) => state.register.selectedIdx)
  const registerVersions = useAppSelector((state) => state.register.registrations)
  const profile = useAppSelector((state) => state.register.selectedRegistration)
  const selectedAdr = useAppSelector((state) => state.docent.selectedDocent)

  const { isInternal } = useUserRoles()

  const toastInstance = useRef<ToastComponent>(null)

  const registerForm = useForm<NwLecturerApplicationDto>({ mode: 'onSubmit', reValidateMode: 'onSubmit' })
  const {
    handleSubmit,
    reset,
    formState: { errors, isDirty },
    setValue,
  } = registerForm


  const [spinnerTarget] = useState<HTMLElement>()
  const [avatarImgSrc] = useState<Blob>()
  const [userSub] = useState<string | undefined>()
  const [newAccountMessage] = useState(false)

  const { showToast } = useToast()

  const { accessToken } = useOidcAccessToken()
  const { oidcUser } = useOidcUser<OidcUserExtendedInfo>()
  const userRoles = oidcUser?.role
  const roleIntern = [appRoles.Intern]

  const navigate = useNavigate()

  const dispatch = useAppDispatch()

  //@ts-ignore
  const bool = useFetchProfileData()


  useEffect(() => {
    if (profile) {
      const newSelectedVersionData = registerVersions.find((version) => version.actualIndex === profile.actualIndex)
      reset({ ...newSelectedVersionData })
    } else {
      navigate('/')
    }
  }, [profile])


  // Bei wechsel des Versions-Dropdown im Header, resette Werte entsprechend dem selektierten Index
  useEffect(() => {
    if (selectedRegIdxFromDd !== null && registerVersions) {
      // version mit übergebenen index:
      const newSelectedVersionData = registerVersions.find((version) => version.actualIndex === selectedRegIdxFromDd)
      if (newSelectedVersionData) {
        reset({ ...newSelectedVersionData })
      }
    }
  }, [registerVersions, reset, selectedRegIdxFromDd])

  // Selektierte AdrId aus Adresse Suchen Dialog wird per redux in form gesetzt
  useEffect(() => {
    if (selectedAdr && selectedAdr.contactId) {
      setValue('adrId', selectedAdr.contactId, { shouldDirty: true })
    }
  }, [selectedAdr])

  // useEffect(() => {
  //   if (userSub) {
  //     if (spinnerTarget) {
  //       showSpinner(spinnerTarget)
  //     }
  //
  //     if (accessToken && (profile || isInternal)) {
  //       const readProfileApiUrl = `${protectedResources.apiList.readProfile}?id=${userSub}`
  //
  //       // Read Profile
  //       fetchDataFromApi(readProfileApiUrl, accessToken, 'GET').then((response) => {
  //         if (spinnerTarget) {
  //           hideSpinner(spinnerTarget)
  //         }
  //         if (response.status === 204) {
  //           // Neuer User
  //           reset({ sub: userSub })
  //           setNewAccountMessage(true)
  //         }
  //
  //         if (response.status === 200) {
  //           // Bereits registrierung gespeichert, Update data
  //           const profileData = response.data as NwLecturerApplicationDto[]
  //
  //           if (profileData.length === 0) {
  //             setNewAccountMessage(true)
  //           }
  //
  //           // Returned Liste mit Versionen, nehmen letzte (aktuellste)
  //           if (profileData.length > 0) {
  //             const mostRecentProfileData = profileData[profileData.length - 1]
  //             reset({ ...mostRecentProfileData })
  //             dispatch(setRegistrations(profileData)) // alle
  //             dispatch(setAddressNr(mostRecentProfileData.adrNo))
  //           }
  //
  //           // Hole Dateiliste inkl Profilbild
  //           const readFilesUrl = `${protectedResources.apiList.readFiles}/${userSub}`
  //
  //           fetchDataFromApi(readFilesUrl, accessToken, 'GET').then((response) => {
  //             const responseData = response.data as NwDbFile[]
  //             dispatch(setFiles(responseData))
  //
  //             if (responseData) {
  //               const avatar = responseData.find((avatar) => avatar.fileTypId === 1)
  //
  //               if (avatar) {
  //                 const readFileContentUrl = `${protectedResources.apiList.readFileContent}/${avatar.id}`
  //
  //                 fetchDataFromApi(readFileContentUrl, accessToken, 'GET', 'blob').then((response) => {
  //                   const data = response.data as Blob
  //                   setAvatarImgSrc(data)
  //                   console.log(response)
  //                 })
  //               }
  //             }
  //           })
  //         }
  //       })
  //     }
  //   }
  // }, [userSub, oidcUser, profile])

  const onSubmit: SubmitHandler<NwLecturerApplicationDto> = (formData) => {
    if (import.meta.env.DEV) console.log(formData)

    const formDataWithLastChangedBy = { ...formData, lastChangedBy: oidcUser.sub }

    const url = `${protectedResources.apiList.createOrUpdateProfile}`
    if (accessToken) {
      if (spinnerTarget) {
        showSpinner(spinnerTarget)
      }
      fetchDataFromApi(url, accessToken, 'POST', 'json', formDataWithLastChangedBy).then((response) => {
        if (spinnerTarget) {
          hideSpinner(spinnerTarget)
        }

        if (response.status === 200) {
          // resette Form mit den return daten des API calls
          const returnData = response.data as NwLecturerApplicationDto

          if (Object.keys(returnData).length > 0) {
            reset({ ...returnData })
            dispatch(addRegistrationToList(returnData)) // alle
          }

          showToast({
            content: 'Ihre Daten wurden erfolgreich übermittelt!',
            type: 'success',
          })
        } else {
          showToast({
            content: 'Bei der Übertragung ist etwas schief gelaufen. Bitte versuchen Sie es später noch einmal.',
            type: 'danger',
          })
        }
      })
    }
  }

  const headerSubmitAndBack = () => {
    return (
      <>
        <ButtonComponent iconCss="e-icons e-chevron-left" className={styles.btnDesktop} onClick={() => navigate('/instructors')}>
          Zur Übersicht
        </ButtonComponent>
        {/* Mobile Button: nur Icon */}
        <ButtonComponent iconCss="e-icons e-chevron-left" className={styles.btnMobile} onClick={() => navigate('/instructors')}></ButtonComponent>

        <ButtonComponent isPrimary form="registerForm" className={styles.btnDesktop} disabled={!isDirty}>
          Speichern
        </ButtonComponent>
        {/* Mobile Button: nur Icon */}
        <ButtonComponent iconCss="e-icons e-save" isPrimary form="registerForm" className={styles.btnMobile} disabled={!isDirty}></ButtonComponent>
      </>
    )
  }

  const headerContentLeft = () => {
    return (
      <>
        <VersionSelectDd responsive={true} />
      </>
    )
  }

  // Zeige Error-Meldung bei Validierungs-Fehlern
  const showValidationErrorMsg = () => {
    if (Object.keys(errors).length > 0) {
      showToast({
        title: 'Fehler',
        content: `Das Formular konnte nicht gesendet werden (${Object.keys(errors).length} Validierungsfehler). Bitte beheben Sie die Fehler und versuchen es erneut.`,
        type: 'danger',
      })
    }
  }

  // Zeige Form-Validierungsfehler bei erstmaligem Validieren
  useEffect(() => {
    showValidationErrorMsg()
  }, [errors])

  const onError: SubmitErrorHandler<NwLecturerApplicationDto> = () => {
    showValidationErrorMsg()
  }

  return (
    <>
      <ToastComponent ref={toastInstance} timeOut={5000} width={'80%'} target={'#targetElement'} />
      <MenuHeaderBar headerContent={'Profil'} contentLeft={headerContentLeft} contentRight={headerSubmitAndBack}></MenuHeaderBar>

      <div className={'nw-content scrollbarOffset'}>
        {!roleIntern.some((role) => userRoles?.includes(role)) && <RegistrationStatusMsg isNewAccount={newAccountMessage} />}

        <FormProvider {...registerForm}>
          <div>
            {isInternal &&
              <SemiAddressAssignment />}
            <form onSubmit={handleSubmit(onSubmit, onError)} id="registerForm">
              <GeneralData />
              <CommunicationData />
              <AddressData />
              <BankData />
              <WebData avatarImgSrc={avatarImgSrc} />
              <QualificationsData />
              <DocumentsData />
              <TopicSelection sub={userSub} />

              <div className={styles.formFooter}>
                <ButtonComponent isPrimary cssClass="btnLarge" disabled={!isDirty}>
                  Speichern
                </ButtonComponent>
              </div>
            </form>
          </div>
        </FormProvider>
      </div>
    </>
  )
}

export default Profile
